const settings = [
  ['People and access', [
    ['users', 'Staff accounts', 'Find staff, assign a location, or manage sign-in access.'],
    ['locations', 'Locations', 'Add, rename, or deactivate a payment location.'],
    ['authorizers', 'Authorization cards', 'Manage the cards used to authorize creation and top-ups.'],
  ]],
  ['Limits and data', [
    ['policy', 'Transaction limits', 'Set balance, top-up, spending, and card limits.'],
    ['snapshots', 'Data snapshots', 'Create or download a snapshot, or review an import undo.'],
  ]],
];
export default function SettingsHome({ onOpen }) {
  return <section className="adminSection settingsHome">
    <h3>Settings</h3><p className="adminMuted">Choose what you want to manage.</p>
    <div className="settingsGroups">{settings.map(([title, items]) => <section key={title}><h4>{title}</h4><ul className="settingsLinks">{items.map(([key, label, description]) => <li key={key}><button type="button" onClick={() => onOpen(key)}><span><strong>{label}</strong><small>{description}</small></span><span aria-hidden="true">→</span></button></li>)}</ul></section>)}</div>
    <details className="settingsMaintenance"><summary>Advanced maintenance</summary><button type="button" className="settingsMaintenanceLink" onClick={() => onOpen('migration')}>Migrate old data</button><p className="adminMuted">Import historical records or assign locations to older transactions.</p></details>
  </section>;
}
